export const calculateExecutedVehiclesPercentage = (
  executedVehiclesNumber: number,
  totalVehiclesNumber: number
): number => {
  const percentage = (executedVehiclesNumber / totalVehiclesNumber) * 100;
  return !isNaN(percentage) ? percentage : 0;
};
